export type DescriptionTexts = {
  gamed: 'string'
}

export enum CaseIdToFolder {
  'trending' = 10,
  'tgGift' = 11,
  'gamed' = 1,
  'telegamApps' = 17,
  'vavilova' = 13,
  'steamDeck' = 14,
  'cargo' = 7,
  'cityholder' = 15,
  'ps5' = 16,
  'halid' = 3,
}
